import styled from 'styled-components'
import { ReactComponent as MaskIcon } from '@sketch/icons/arrow-left-down-17'

export const ElementIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

export const StyledMaskedIcon = styled(MaskIcon)`
  width: 17px;
  height: 17px;
  margin-top: 1px; /* stylelint-disable-line scales/space */
`
